module.exports = __webpack_public_path__ + "img/top.320f24c7.png";